// extracted by mini-css-extract-plugin
export var formContainer = "_ga-0";
export var message = "_ga-1";